import React, {
    PropTypes,
} from 'react';
import {history} from '../../redux/store';
import {connect} from 'react-redux';
import {UserLogout} from './actions'

class LogoutView extends React.Component {
    componentDidMount() {
        this.props.UserLogout();
        history.push('/login');
    }

    render() {
        return (
            <div>You're now logging out</div>
        );
    }
}

LogoutView.propTypes = {
    UserLogout: PropTypes.func.isRequired,
};

export default connect(null, {UserLogout})(LogoutView);



/** WEBPACK FOOTER **
 ** ./src/modules/auth/LogoutView.js
 **/